<h1 class="mb-3">Создание новости</h1>
@if (form) {
  <form class="form form_crm" [formGroup]="form" novalidate (submit)="onSubmit()">
    <div class="row no-gutters gutters-4">
      <div class="col-12">
        <app-material-input formControlName="news_title"
          [placeholder]="'Заголовок'"
          [require]="true">
        Заголовок</app-material-input>
      </div>
      <div class="col-12">
        <app-wysiwyg-editor [placeholder]="'Краткое описание'" formControlName="news_description"></app-wysiwyg-editor>
      </div>
      <div class="col-md-4">
        <app-material-input-dropimage
          formControlName="file"
          [cssClass]="'m-h-none embed-responsive embed-responsive-1by1 visible'"
          [cssClassZone]="'zone-photo'"
          [uploadOptions]="{'exclude_compressing': true}"
          >
          Перетащите сюда иллюстрацию в пропорциях 2:1
        </app-material-input-dropimage>
      </div>
      <div class="col-md-10 mt-2">
        <app-material-select2 [caption]="'Теги'"
          [multiple]="true"
          formControlName="tags">
          @for (tag of dictTags; track tag) {
            <option [value]="tag.id">
            {{tag.caption}}</option>
          }
        </app-material-select2>
      </div>
      <div class="col-12 mt-1">
        <app-material-input formControlName="news_link"
          [placeholder]="'Ссылка'"
          [require]="true">
        Ссылка</app-material-input>
      </div>
      <div class="col-md-2 pt-2">
        <app-material-input-checkbox formControlName="always_show" [cssClass]="'mb-0'" [border]="true">
          Всегда всплывает
        </app-material-input-checkbox>
      </div>
      <div class="col-md-2 pt-2">
        <app-material-input-checkbox formControlName="is_view_news_list" [cssClass]="'mb-0'" [border]="true">
          Показывать в сводке
        </app-material-input-checkbox>
      </div>
      <div class="col-md-2 pt-2">
        <app-material-input-checkbox formControlName="is_view_vitrine" [cssClass]="'mb-0'" [border]="true">
          Показывать на витрине
        </app-material-input-checkbox>
      </div>
      <div class="col-md-2">
        <app-material-select [require]="true" [caption]="'Публикация на:'" formControlName="public_status">
          <option [value]="'crm'">СА</option>
          <option [value]="'site'">САЙТ</option>
          <option [value]="'site_crm'">САЙТ+СА</option>
        </app-material-select>
      </div>
      <div class="col-md-2">
        <app-material-input-datepicker formControlName="news_date"
          [placeholder]="'Дата публикации'"
          [require]="true">
        Дата публикации</app-material-input-datepicker>
      </div>
      <div class="col-md-2 pt-2">
        <app-material-input-checkbox formControlName="is_archive" [cssClass]="'mb-0'" [border]="true">
          В архиве
        </app-material-input-checkbox>
      </div>
    </div>
    <div class="row no-gutters gutters-2 mt-3 mb-5 mb-md-0">
      <div class="col-8">
        <button type="submit" class="button button_sm" [disabled]="!form.valid">Сохранить и закрыть</button>
      </div>
      <div class="col-4 text-right">
        <button type="button" class="button button_sm" (click)="onCancelClick()">Отмена</button>
      </div>
    </div>
  </form>
}

